import DOMPurify from 'dompurify';
import SyncMapsUpdateAccordion from '../../../components/sections/sync-maps-update-accordion/sync-maps-update-accordion';
import SyncMapsVehicleCard from '../../../components/sections/sync-maps-vehicle-card/sync-maps-vehicle-card';
import React from 'react';
import {
    SyncMapAccordionContent,
    SyncMapsConsolidatedResponse,
} from '../../../views/sync-maps-updates-view/hooks/use-syncs-maps-status-updates';
import { useSyncCitivanCheckVersion } from '../../../views/sync-maps-updates-view/hooks/use-sync-citivan-check-a-version';
import SyncMapsArticleContent from '../../../components/sections/sync-maps-article-content/sync-maps-article-content';
import { useExperienceContent } from '../../../hooks/use-server-content';
import { FeatureLinksListFragment } from '../../../models/experiencefragments/featurelinkslist';

interface Props {
    setSyncOption: (event: any) => void;
    setMapsOption: (event: any) => void;
    syncAccordionContent: SyncMapAccordionContent;
    vwAccordionContent: SyncMapAccordionContent;
    mapAccordionContent: SyncMapAccordionContent;
    syncMapsUpdates: SyncMapsConsolidatedResponse;
}

const SyncMapsUpdatesVw = (props: Props) => {
    const contentCitivanVersion = useSyncCitivanCheckVersion();

    const [articlesContent] = useExperienceContent<FeatureLinksListFragment>(
        'sync',
        'sync-maps-articles',
        'featurelinkslist',
        undefined,
        false
    );

    return (
        <>
            {props.vwAccordionContent.hasVw ? (
                <div className="sync-maps-accordions-and-card">
                    <div className="sync-maps-updates-accordions">
                        {props.syncAccordionContent.cards && (
                            <SyncMapsUpdateAccordion
                                setSelectedOption={props.setSyncOption}
                                syncMapsConsolidatedResponse={
                                    props.syncMapsUpdates
                                }
                                {...props.syncAccordionContent}
                            />
                        )}

                        {props.vwAccordionContent.cards && (
                            <SyncMapsUpdateAccordion
                                setSelectedOption={props.setSyncOption}
                                {...props.vwAccordionContent}
                            />
                        )}
                    </div>

                    <div className="sync-maps-vehicle-and-article">
                        <SyncMapsVehicleCard
                            syncMapsConsolidatedResponse={props.syncMapsUpdates}
                            hasVW={props.vwAccordionContent.hasVw}
                            releaseDate={props.vwAccordionContent.vwVersion}
                            vwContent={contentCitivanVersion}
                        />
                        {contentCitivanVersion && (
                            <div className="sync-maps-articles">
                                <h3 className="articles-heading">
                                    {contentCitivanVersion.title}
                                </h3>

                                <div
                                    className="article-description"
                                    dangerouslySetInnerHTML={{
                                        __html: DOMPurify.sanitize(
                                            contentCitivanVersion.description
                                        ),
                                    }}
                                />
                            </div>
                        )}
                    </div>
                </div>
            ) : (
                <div className="sync-maps-accordions-and-card">
                    <div className="sync-maps-updates-accordions">
                        {props.syncAccordionContent.cards && (
                            <SyncMapsUpdateAccordion
                                setSelectedOption={props.setSyncOption}
                                syncMapsConsolidatedResponse={
                                    props.syncMapsUpdates
                                }
                                {...props.syncAccordionContent}
                            />
                        )}

                        {props.mapAccordionContent.cards && (
                            <SyncMapsUpdateAccordion
                                setSelectedOption={props.setMapsOption}
                                {...props.mapAccordionContent}
                            />
                        )}
                    </div>

                    <div className="sync-maps-vehicle-and-article">
                        <SyncMapsVehicleCard
                            syncMapsConsolidatedResponse={props.syncMapsUpdates}
                            hasSync={props.syncAccordionContent.hasSync}
                        />

                        {articlesContent && (
                            <div className="sync-maps-articles">
                                {articlesContent.categories.map(item => (
                                    <SyncMapsArticleContent
                                        key={item.categoryTitle}
                                        {...item}
                                    />
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default SyncMapsUpdatesVw;
